import { ResponseError } from '@ynap/api-utils'

import { SET_QUANTITY_ERROR } from '../constants/ActionTypes'
import GenericAction from './types/genericAction.types'

type SetQuantityErrorAction = GenericAction<typeof SET_QUANTITY_ERROR, { partNumber: number | string; error: ResponseError }>

export default function setQuantityError(state = {}, action: SetQuantityErrorAction) {
    switch (action.type) {
        case SET_QUANTITY_ERROR:
            return { ...state, [action.partNumber.toString()]: action.error.message }

        default:
            if (Object.keys(state).length > 0) {
                return {}
            }
            return state
    }
}
